import { Card, Text } from "@components/theming";
import React from "react";

interface Props {
  discount: {
    id: number;
    name: string;
    description: string | null;
  };
}

const DiscountInformation = ({ discount }: Props) => {
  return (
    <Card
      key={discount.id}
      size="2"
      shopsiteClasses="bg-indigo-100 rounded-2xl p-3"
    >
      <div className="flex gap-y-2 flex-col">
        <Text
          as="span"
          size="5"
          weight="bold"
          shopsiteClasses="text-base text-indigo-600 font-bold"
        >
          {discount.name}
        </Text>
        {discount.description ? (
          <Text
            as="p"
            size="2"
            color="gray"
            shopsiteClasses="text-sm leading-5 text-indigo-500"
          >
            {discount.description}
          </Text>
        ) : (
          <></>
        )}
      </div>
    </Card>
  );
};

export default DiscountInformation;
